/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */

export type PayoutStatus = typeof PayoutStatus[keyof typeof PayoutStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PayoutStatus = {
  Scheduled: 'Scheduled',
  Released: 'Released',
  Processing: 'Processing',
  Paid: 'Paid',
  Failed: 'Failed',
  Voided: 'Voided',
} as const;
